// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();

// Dark mode toggle
const toggle = document.querySelector('.v-theme-toggle');
if (toggle) {
  toggle.addEventListener('click', () => {
    const html = document.documentElement;
    const current = html.getAttribute('data-color-scheme');
    const next = current === 'dark' ? 'Light' : 'dark';
    html.setAttribute('data-color-scheme', next);
    localStorage.setItem('vestige-color-scheme', next);
  });

  // Restore saved preference
  const saved = localStorage.getItem('vestige-color-scheme');
  if (saved) {
    document.documentElement.setAttribute('data-color-scheme', saved);
  }
}

// Listen for dark mode toggle from parent (storefront demo iframe)
window.addEventListener('message', (e) => {
  if (e.data && e.data.type === 'setColorScheme') {
    document.documentElement.setAttribute('data-color-scheme', e.data.scheme);
  }
});